import {
  GET_PLATFORM_CONFIG,
  GET_PLATFORM_CONFIG_SUCCESS,
  GET_PLATFORM_CONFIG_FAILURE,
} from "store/constants/PlatformConfig";

const INIT_STATE = {
  platformConfig: {},
  loadingPlatformConfig: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PLATFORM_CONFIG:
      return {
        ...state,
        loadingPlatformConfig: true,
      };
    case GET_PLATFORM_CONFIG_SUCCESS:
      if (action?.payload?.ok) {
        const { TIMEOFF_ALLOWED_COUNTRIES, TIMEOFF_ALLOWED_COUNTRIES_V2 } = action.payload.payload || {};

        if (TIMEOFF_ALLOWED_COUNTRIES_V2) {
          localStorage.setItem("TIMEOFF_ALLOWED_COUNTRIES_V2", TIMEOFF_ALLOWED_COUNTRIES_V2);
        }
        if (TIMEOFF_ALLOWED_COUNTRIES) {
          localStorage.setItem("TIMEOFF_ALLOWED_COUNTRIES", TIMEOFF_ALLOWED_COUNTRIES);
        }
      }
      return {
        ...state,
        loadingPlatformConfig: false,
        platformConfig: action.payload,
      };
    case GET_PLATFORM_CONFIG_FAILURE:
      return {
        ...state,
        loadingPlatformConfig: false,
        platformConfig: "Error in  getting Club Data",
      };
    default:
      return state;
  }
};
